import './App.css';
import {ThemeProvider} from '@mui/material/styles';
import Dashboard from './pages/Dashboard/Home.tsx';
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {PeriodProvider} from './context/PeriodContext';
import {demoTheme} from './config/theme';

// AuthProvider is mounted in index.js (wraps the Keycloak instance).
// By the time this component renders, the user is always authenticated —
// the Keycloak adapter (onLoad:'login-required') redirects unauthenticated
// users to the Keycloak login page before React mounts.
function App() {
    return (
        <ThemeProvider theme={demoTheme}>
            <PeriodProvider>
                <Router>
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard/>}/>
                        <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
                    </Routes>
                </Router>
            </PeriodProvider>
        </ThemeProvider>
    );
}

export default App;
